const baseEnvironment = process.env.REACT_APP_API_BASE_URL?.trim() || 'http://localhost:8010';
const API_BASE = baseEnvironment.replace(/\/$/, '');

const buildHeaders = () => {
  const token = sessionStorage.getItem('authToken');
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

const handleErrors = async (response, defaultMessage) => {
  if (response.ok) {
    if (response.status === 204) {
      return null;
    }
    return response.json();
  }
  const body = await response.json().catch(() => ({}));
  if (body.code === 'PACKAGE_LIMIT_EXCEEDED' || body.code === 'PACKAGE_FEATURE_DISABLED') {
    throw new Error(body.message);
  }
  throw new Error(body.detail || body.message || defaultMessage || `Request failed (${response.status})`);
};

export async function listStressScenarios(companyId) {
  const params = new URLSearchParams({ companyId: String(companyId) });
  const response = await fetch(`${API_BASE}/api/stress-scenarios?${params.toString()}`, { headers: buildHeaders() });
  return handleErrors(response, 'Senaryo listesi alinamadi.');
}

export async function getStressScenario(id) {
  const response = await fetch(`${API_BASE}/api/stress-scenarios/${id}`, { headers: buildHeaders() });
  return handleErrors(response, 'Senaryo detayi alinamadi.');
}

export async function createStressScenario(payload) {
  const response = await fetch(`${API_BASE}/api/stress-scenarios`, {
    method: 'POST',
    headers: buildHeaders(),
    body: JSON.stringify(payload)
  });
  return handleErrors(response, 'Senaryo olusturulamadi.');
}

export async function updateStressScenario(id, payload) {
  const response = await fetch(`${API_BASE}/api/stress-scenarios/${id}`, {
    method: 'PUT',
    headers: buildHeaders(),
    body: JSON.stringify(payload)
  });
  return handleErrors(response, 'Senaryo guncellenemedi.');
}

export async function deleteStressScenario(id) {
  const response = await fetch(`${API_BASE}/api/stress-scenarios/${id}`, {
    method: 'DELETE',
    headers: buildHeaders()
  });
  return handleErrors(response, 'Senaryo silinemedi.');
}

export async function runStressScenario(id) {
  const response = await fetch(`${API_BASE}/api/stress-scenarios/${id}/run`, {
    method: 'POST',
    headers: buildHeaders()
  });
  return handleErrors(response, 'Senaryo calistirilamadi.');
}

export async function getLatestStressSnapshot(id) {
  const response = await fetch(`${API_BASE}/api/stress-scenarios/${id}/latest-snapshot`, { headers: buildHeaders() });
  return handleErrors(response, 'Snapshot alinamadi.');
}

export async function generateStressAiReport(snapshotId, payload = {}) {
  const response = await fetch(`${API_BASE}/api/stress-snapshots/${snapshotId}/ai-report`, {
    method: 'POST',
    headers: buildHeaders(),
    body: JSON.stringify(payload)
  });
  return handleErrors(response, 'AI raporu olusturulamadi.');
}

export async function getStressAiReport(snapshotId) {
  const response = await fetch(`${API_BASE}/api/stress-snapshots/${snapshotId}/ai-report`, { headers: buildHeaders() });
  return handleErrors(response, 'AI raporu alinamadi.');
}

const analysisStressTestService = {
  listStressScenarios,
  getStressScenario,
  createStressScenario,
  updateStressScenario,
  deleteStressScenario,
  runStressScenario,
  getLatestStressSnapshot,
  generateStressAiReport,
  getStressAiReport
};

export default analysisStressTestService;
